import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class DialogRef {
  public visible: boolean = true;

  constructor() {
  }
  
  public close(result?: any): void {
    this.visible = false;
   
    this._afterClosed.next(result);
  }
  private readonly _afterClosed = new Subject<any>();
  public afterClosed: Observable<any> = this._afterClosed.asObservable();
}